// Header: su desktop il menu è sempre aperto; un solo sottomenu aperto alla volta; Esc o clic fuori chiudono.
(function () {
  var menu = document.querySelector('[data-menu]');
  if (!menu) return;
  var wide = matchMedia('(min-width: 900px)');
  var subs = menu.querySelectorAll('.submenu');
  function sync() { menu.open = wide.matches; }
  sync();
  wide.addEventListener('change', sync);
  subs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) subs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
  function closeAll(e) {
    subs.forEach(function (d) { if (!e || !d.contains(e.target)) d.open = false; });
    if (!wide.matches && (!e || !menu.contains(e.target))) menu.open = false;
  }
  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = menu.querySelector('.submenu[open]');
    closeAll();
    if (open) open.querySelector('summary').focus();
  });
})();
